module.exports = __webpack_public_path__ + "img/ss-only.66b50d4a.svg";